<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="services"
        :search="search"
        :items-per-page="30"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="order"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="orderDialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mb-2 mr-2"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @click="openOrderDialog"
                >
                  <v-icon class="mr-2">mdi-sort-variant</v-icon>
                  {{ $t("button.manageOrder") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ $t("title.serviceOrder") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-list dense>
                    <draggable v-model="orderItems" handle=".drag-handle">
                      <div
                        v-for="(element, index) in orderItems"
                        :key="element.orderKey || element.code || index"
                      >
                        <v-list-item class="px-0">
                          <v-list-item-icon class="mr-2">
                            <v-icon class="drag-handle">mdi-drag</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                element && element.name
                                  ? element.name
                                  : element && element.code
                                    ? element.code
                                    : "-"
                              }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ $t("table.order") }}: {{ index }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                      </div>
                    </draggable>
                  </v-list>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="orderDialog = false">
                    {{ $t("button.cancel") }}
                  </v-btn>
                  <v-btn color="primary" @click="saveOrder">
                    {{ $t("button.save") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialog" max-width="900px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="newItem()"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" class="pa-3">
                      <v-row>
                        <v-col cols="12" sm="8">
                          <v-text-field
                            v-model="editedItem.name"
                            :items="services"
                            item-text="name"
                            item-value="name"
                            :return-object="false"
                            :label="$t('name')"
                            :rules="rules.fieldRequired"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model="editedItem.code"
                            label="Codigo"
                            :rules="rules.fieldRequired"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-text-field
                            v-model.number="editedItem.order"
                            :label="$t('form.order')"
                            type="number"
                            :rules="orderRules"
                          />
                        </v-col>
                      </v-row>
                      <v-row class="align-center">
                        <v-col cols="11" sm="6" md="6">
                          <v-combobox
                            v-if="hosts && hosts.length > 0"
                            v-model="editedItem.host"
                            :items="hosts"
                            item-text="hostname"
                            item-value="id"
                            label="Host"
                            clearable
                          >
                          <template v-slot:selection="{ item }">
                            <v-list-item>
                              {{ item.hostname }}
                            </v-list-item>
                          </template>
                          <template v-slot:item="{ item, on }">
                            <v-list-item v-on="on">
                              {{ item.hostname }}
                            </v-list-item>
                          </template>
                          </v-combobox>
                        </v-col>
                        <v-col class="align-center" cols="1">
                          <v-btn
                            icon
                            to="/manage/edit/hosts"
                          >
                            <v-icon
                              color="green"
                              v-tooltip.top-center="$t('info.tooltip.addHost')"
                            >
                              mdi-plus
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <h5>{{ $t("form.description") }}</h5>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-tabs v-model="tab_description">
                            <v-tab
                              class="capitalize"
                              v-for="(item, index) in Object.keys(editedItem.description)"
                              :key="index"
                            >
                              {{ $t("form." + item) }}
                            </v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab_description">
                            <v-tab-item
                              class="mt-2"
                              v-for="(item, index) in Object.keys(editedItem.description)"
                              :key="index"
                            >
                              <EditorText
                                :key="item"
                                :text="editedItem.description[item]"
                                :language="item"
                                field="description"
                                @change-content="changeContent"
                              />
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                      <h5>{{ $t("form.contact_people") }}</h5>
                      <SelectPeopleList :items-selected="editedItem.contact_people" />
                      <v-row class="mt-2">
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="editedItem.exclusive_with"
                            :items="exclusiveWithOptions"
                            item-text="name"
                            item-value="id"
                            :label="$t('form.exclusive_with')"
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            clearable
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <v-row class="mt-2">
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.basic"
                            :label="$t('table.basicService')"
                            :rules="rules.checkboxRequired"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.restricted"
                            :label="$t('form.restricted')"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.requires_agreement"
                            :label="$t('form.requires_agreement')"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.hidden"
                            :label="$t('form.hidden')"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.available_in_forms"
                            :label="$t('form.available_in_forms')"
                          />
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-checkbox
                            v-model="editedItem.create_ldap_group"
                            :label="$t('form.create_ldap_group')"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.documentation_link"
                            :label="$t('form.documentation_link')"
                            outlined
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.features="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-1"
                :color="item.basic ? 'amber' : 'grey'"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.basic ? 'mdi-star-circle' : 'mdi-star-circle-outline' }}
              </v-icon>
            </template>
            {{ item.basic ? $t("table.features.basicService") : $t("table.features.notBasicService") }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-1"
                :color="item.restricted ? 'red' : 'grey'"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.restricted ? 'mdi-lock' : 'mdi-lock-open' }}
              </v-icon>
            </template>
            {{ item.restricted ? $t("table.features.restricted") : $t("table.features.notRestricted") }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="item.requires_agreement ? 'blue' : 'grey'"
                v-bind="attrs"
                v-on="on"
              >
                {{ item.requires_agreement ? 'mdi-file-sign' : 'mdi-file-document-outline' }}
              </v-icon>
            </template>
            {{ item.requires_agreement ? $t("table.features.requiresAgreement") : $t("table.features.notRequiresAgreement") }}
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ml-1"
                :color="item.exclusive_with && item.exclusive_with.length ? 'orange' : 'grey'"
                v-bind="attrs"
                v-on="on"
              >
                mdi-call-split
              </v-icon>
            </template>
            {{ exclusiveServicesTooltip(item) }}
          </v-tooltip>
          <v-tooltip v-if="item.hidden" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ml-1"
                color="grey"
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye-off
              </v-icon>
            </template>
            {{ $t("table.features.hiddenService") }}
          </v-tooltip>
          <v-tooltip v-if="item.documentation_link" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="ml-1"
                color="blue"
                v-bind="attrs"
                v-on="on"
              >
                mdi-link-variant
              </v-icon>
            </template>
            {{ $t("table.features.documentationLink") }}
          </v-tooltip>
        </template>
        <template v-slot:item.hostname="{ item }">{{
          getHostName(item.host)
        }}</template>
        <template v-slot:item.order="{ item }">
          {{ item.order }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import EditorText from "../../components/reusables/EditorText";
import SelectPeopleList from "../../components/reusables/SelectPeopleList";
import draggable from "vuedraggable";
import {
  extractRelationIds,
  normalizeService,
  normalizeServiceDescription,
  normalizeServices
} from "../../utils/service";
export default {
  components: { EditorText, SelectPeopleList, draggable },
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      orderDialog: false,
      linkedEditOpened: false,
      search: "",
      services: [],
      hosts: [],
      tab_description: 0,
      orderItems: [],
      orderRules: [
        v =>
          v === null ||
          v === undefined ||
          v === "" ||
          (Number(v) >= 0 && Number(v) <= 100) ||
          this.$t("forms.field.validation.range")
      ],
      editedIndex: -1,
      editedItem: {
        name: "",
        code: "",
        host: null,
        basic: false,
        order: 0,
        hidden: false,
        available_in_forms: true,
        description: { es: "", en: "", gl: "" },
        contact_people: [],
        exclusive_with: [],
        restricted: false,
        requires_agreement: false,
        create_ldap_group: false,
        documentation_link: ""
      },
      defaultItem: {
        name: "",
        code: "",
        host: null,
        basic: false,
        order: 0,
        hidden: false,
        available_in_forms: true,
        description: { es: "", en: "", gl: "" },
        contact_people: [],
        exclusive_with: [],
        restricted: false,
        requires_agreement: false,
        create_ldap_group: false,
        documentation_link: ""
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    services() {
      if (this.orderDialog) {
        this.openOrderDialog();
      }
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    exclusiveWithOptions() {
      return this.services
        .filter(service => {
          if (!service) {
            return false;
          }
          if (
            this.editedItem &&
            this.editedItem.id !== undefined &&
            this.editedItem.id !== null
          ) {
            return service.id !== this.editedItem.id;
          }
          return true;
        })
        .sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""))
        );
    },
    headers() {
      return [
        {
          text: this.$t("table.service"),
          value: "name"
        },
        {
          text: this.$t("table.code"),
          value: "code"
        },
        {
          text: "Host",
          value: "hostname"
        },
        {
          text: this.$t("table.order"),
          value: "order"
        },
        {
          text: this.$t("table.characteristics"),
          value: "features",
          sortable: false
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
    this.getHosts();
  },

  methods: {
    openOrderDialog() {
      this.orderItems = this.services
        .filter(item => item)
        .map((item, index) => {
          const orderIdentifier =
            item.id !== undefined && item.id !== null ? item.id : item.code;
          return Object.assign({}, item, {
            orderKey: orderIdentifier || `idx-${index}`,
            orderIdentifier
          });
        })
        .sort((a, b) => {
          const orderDiff = (a.order || 0) - (b.order || 0);
          if (orderDiff !== 0) {
            return orderDiff;
          }
          return String(a.name || "").localeCompare(String(b.name || ""));
        });
      this.orderDialog = true;
    },
    initialize() {
      let path = this.$store.state.endpoint + "/service";
      axios
        .get(path)
        .then(response => {
          this.services = normalizeServices(response.data);
          const linked = this.services.find(item => String(item.id) === String(this.$route.query.edit));
          if (linked && !this.linkedEditOpened) { this.linkedEditOpened = true; this.editItem(linked); }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getHosts() {
      let path = this.$store.state.endpoint + "/host";
      axios
        .get(path)
        .then(response => {
          this.hosts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getHostName(item) {
      if (item !== null) {
        if (typeof item === "number") {
          const host = this.hosts.find(host => host.id === item);
          return host ? host.hostname : null;
        } else {
          return item.hostname;
        }
      } else {
        return null;
      }
    },
    editItem(item) {
      this.editedIndex = this.services.indexOf(item);
      this.editedItem = this.normalizeEditableService(item);
      this.dialog = true;
    },
    newItem() {
      this.resetEditedItem();
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/service/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.services.indexOf(item);
            this.services.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.resetEditedItem();
        this.editedIndex = -1;
        this.tab_description = 0;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        const data = this.buildPayload();
        const snapshot = this.cloneEditedItem();
        if (index > -1) {
          path = this.$store.state.endpoint + "/service/" + this.editedItem.id;
          axios
            .patch(path, data)
            .then(response => {
              snapshot.host =
                data.host !== null
                  ? { id: data.host, hostname: this.getHostName(data.host) }
                  : null;
              Object.assign(this.services[index], snapshot);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/service";
          axios
            .post(path, data)
            .then(response => {
              snapshot.id = response.data.id;
              snapshot.host =
                data.host !== null
                  ? { id: data.host, hostname: this.getHostName(data.host) }
                  : null;
              this.services.push(snapshot);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    },
    changeContent(lan, content, field) {
      if (!this.editedItem[field]) {
        this.editedItem[field] = this.normalizeDescription();
      }
      this.editedItem[field][lan] = content;
    },
    normalizeDescription(value = null) {
      return normalizeServiceDescription(value);
    },
    exclusiveServicesTooltip(service) {
      const names = this.getExclusiveServiceNames(service);
      if (names.length === 0) {
        return this.$t("table.features.noExclusiveServices");
      }
      return this.$t("form.exclusive_with") + ": " + names.join(", ");
    },
    getExclusiveServiceNames(service) {
      if (!service || !Array.isArray(service.exclusive_with)) {
        return [];
      }
      return service.exclusive_with
        .map(item => {
          if (item && typeof item === "object" && item.name) {
            return item.name;
          }
          const serviceId =
            item && typeof item === "object" ? item.id : item;
          const found = this.services.find(candidate => candidate && candidate.id === serviceId);
          return found && found.name ? found.name : "";
        })
        .filter(name => name);
    },
    normalizeEditableService(service) {
      const normalized = normalizeService(service) || {};
      return Object.assign({}, this.defaultItem, normalized, {
        id: service && service.id,
        description: this.normalizeDescription(normalized.description),
        contact_people: Array.isArray(normalized.contact_people)
          ? normalized.contact_people.map(item =>
              typeof item === "number"
                ? { id: item, name: "" }
                : Object.assign({}, item)
            )
          : [],
        exclusive_with: extractRelationIds(normalized.exclusive_with)
      });
    },
    buildPayload() {
      const data = Object.assign({}, this.editedItem);
      if (data.host && typeof data.host === "object") {
        data.host = data.host.id;
      }
      data.contact_people = this.editedItem.contact_people
        .map(item => {
          if (typeof item === "number") {
            return item;
          }
          return item && item.id != null ? item.id : null;
        })
        .filter(item => item != null);
      data.description = this.normalizeDescription(data.description);
      data.exclusive_with = extractRelationIds(data.exclusive_with);
      data.basic = data.basic === true;
      data.order =
        data.order === "" || data.order === null || data.order === undefined
          ? 0
          : Number(data.order);
      data.hidden = data.hidden === true;
      data.available_in_forms = data.available_in_forms === true;
      data.restricted = data.restricted === true;
      data.requires_agreement = data.requires_agreement === true;
      data.create_ldap_group = data.create_ldap_group === true;
      data.documentation_link = data.documentation_link || "";
      return data;
    },
    cloneEditedItem() {
      return this.normalizeEditableService(this.editedItem);
    },
    resetEditedItem() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.description = this.normalizeDescription(
        this.defaultItem.description
      );
      this.editedItem.contact_people = [];
    },
    saveOrder() {
      const updates = this.orderItems
        .filter(service => service && service.orderIdentifier)
        .map((service, index) => {
          const orderValue = Math.min(index, 100);
          return axios.patch(
            this.$store.state.endpoint + "/service/" + service.orderIdentifier,
            { order: orderValue }
          );
        });
      Promise.all(updates)
        .then(() => {
          this.orderItems.forEach((service, index) => {
            if (!service) {
              return;
            }
            const orderValue = Math.min(index, 100);
            const existing = this.services.find(item =>
              (service.id !== undefined && service.id !== null && item.id === service.id) ||
              (service.code && item.code === service.code)
            );
            if (existing) {
              existing.order = orderValue;
            }
          });
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.updateItem")
          });
          this.orderDialog = false;
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: error.response && error.response.data
              ? error.response.data
              : error
          });
        });
    }
  }
};
</script>
